import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  ActivityIndicator,
  Dimensions,
} from 'react-native';

const deviceWidth = Dimensions.get('window').width;
const deviceHeight = Dimensions.get('window').height;

const styles = StyleSheet.create({
  loadingScreenContainer: {
    width: deviceWidth,
    height: deviceHeight,
    justifyContent: 'center',
  },

  loadingTextContainer: {
    alignItems: 'center',
    padding: 10,
  },
});

export default function Loading({ loadingText }) {
  return (
    <View style={styles.loadingScreenContainer}>
      <View>
        <ActivityIndicator size="large" />
      </View>
      <View style={styles.loadingTextContainer}>
        <Text>{loadingText}</Text>
      </View>
    </View>
  );
}
